import React from "react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative py-16 border-t border-white/10 bg-slate-950"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <div className="mb-5">
              <img
                src="/logo.png"
                alt="Sin aletas no hay paraíso"
                className="h-14 w-auto"
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
              Una iniciativa independiente de conservación marina y educación oceánica.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-medium text-cyan-400 mb-4">
              Navegación
            </div>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><a href="#about" className="hover:text-cyan-400 transition">El proyecto</a></li>
              <li><a href="#founder" className="hover:text-cyan-400 transition">La fundadora</a></li>
              <li><a href="#how" className="hover:text-cyan-400 transition">Cómo funciona</a></li>
              <li><a href="#stats" className="hover:text-cyan-400 transition">Por qué importa</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-medium text-cyan-400 mb-4">
              Contacto
            </div>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <a
                  href="mailto:hola@sinaletasnohayparaiso.org"
                  data-testid="footer-email"
                  className="hover:text-cyan-400 transition"
                >
                  hola@sinaletasnohayparaiso.org
                </a>
              </li>
            </ul>
            <a
              href="#register"
              data-testid="footer-cta"
              className="inline-block mt-5 text-cyan-400 hover:text-cyan-300 text-sm font-semibold border-b border-cyan-400/40 hover:border-cyan-300 pb-0.5 transition"
            >
              Únete a la campaña →
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Sin Aletas No Hay Paraíso. Todos los derechos reservados.
          </p>
          <p className="text-xs text-slate-500">
            Hecho con respeto por el océano <span className="text-cyan-400">⌁</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
